{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".videos_sliders");
      MultipleSliders.forEach((slider, index) => {
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          centeredSlides: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
          },
          speed: 1000,
          breakpoints: {
            150: {
              slidesPerView: 2.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 3.2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 4.1,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 4.2,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".imgBoxes_sliders");
      MultipleSliders.forEach((slider, index) => {
        new Swiper(slider, {
          direction: "horizontal",
          navigation: {
            nextEl: ".swiperNavNext",
            prevEl: ".swiperNavPrev",
          },
          speed: 800,
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3.2,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
